import React from 'react';

import { Content } from './Content.js';
import NrgComponent from './../NrgComponent.jsx';
import getIcon from '../../icons/svgController.js';

// import { ReactComponent as LogoHarrisIcon } from '../../icons/svg/logo-harris.svg';

export default class LogosExtension extends NrgComponent {
  constructor(props) {
    super(props);

    this.listOfDirectImageLoading = ["logo-finn", "logo-harris", "logo-harrisx", "logo-mmi", "logo-scout", "logo-stagtech", "logo-targ", "logo-wolf", "logo-forward"];
  }

  createIconHelper = (icon) => {
    let isLoadImage = false;
    for (let i = 0; i < this.listOfDirectImageLoading.length; i++) {
      if (this.listOfDirectImageLoading[i] == icon.iconName) {
        isLoadImage = true;
      }
    }

    if (isLoadImage) {
      return <img className="direct-image-logo" style={{}} src={"../../icons/svg/" + icon.iconName + ".svg"}></img>
    }
    else {
      let Icon = getIcon(icon.iconName);
      return icon.iconName && <Icon viewBox={icon.viewBox}></Icon>
    }
  }
  render() {
    var icons = Content.extension.logos;

    return (
      <div className="LogosExtension">
        <div className="row">
          {icons.map((icon, index) => {
            return <div className="col-xs-8 col-md-16 col-lg-8" key={index}>
              <div className={`network-container ${icon.className}`}>
                <div className="logo-wrapper">
                  <a className={["network-logo", icon.className].join(" ")} href={icon.href}>
                    {this.createIconHelper(icon)}
                  </a>
                </div>
              </div>
            </div>
          })}
          <div className="col-xs-16 stagwell">
            <div className="stagwell-container">
              <a href={Content.extension.anchor.href} target="_blank" rel="noopener noreferrer">
                {Content.extension.anchor.text}
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }

};
